import React, { Component } from 'react'
import { connect } from 'react-redux'
import { User as User24 } from 'projects/flow-gui-access/views/2.4/users'

class User extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'users').length !== 0) {
      return <User24 {...this.props} />
    } else {
      return null
    }
  }
}

export default connect(state => state)(User)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/users/user.js